import {
  Table,
  Text,
} from '@mantine/core'

export interface FlowReading {
  time: string
  value: number
}

const formatTime = (time: string) => {
  const date = new Date(time)
  return Number.isNaN(date.getTime()) ? time : date.toLocaleTimeString()
}

interface RealTimeFlowTableProps {
  readings: FlowReading[]
}

function RealTimeFlowTable({ readings }: RealTimeFlowTableProps) {
  let runningSum = 0
  const rows = readings.map((reading, index) => {
    runningSum += reading.value
    return { ...reading, rollingAverage: runningSum / (index + 1) }
  }).reverse()

  return (
    <Table withTableBorder>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Time</Table.Th>
          <Table.Th>Flow (l/min)</Table.Th>
          <Table.Th>Rolling Avg (l/min)</Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {rows.length ? (
          rows.map((reading) => (
            <Table.Tr key={`${reading.time}_${reading.value}`}>
              <Table.Td>{formatTime(reading.time)}</Table.Td>
              <Table.Td>{reading.value.toFixed(2)}</Table.Td>
              <Table.Td>{reading.rollingAverage.toFixed(2)}</Table.Td>
            </Table.Tr>
          ))
        ) : (
          <Table.Tr>
            <Table.Td colSpan={3}>
              <Text fs={'italic'} c={'dimmed'}>
                No data received yet
              </Text>
            </Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  )
}

export default RealTimeFlowTable
